module.exports = __webpack_public_path__ + "img/user-circle-white.93dd6c30.svg";